module.exports = __webpack_public_path__ + "media/images/pic/compare/old/after-eee582cd03d2095ecaf9ca587d60c7eb.jpg";